import {createBrowserHistory} from 'history';

// eslint-disable-next-line no-restricted-globals
export default createBrowserHistory(location);
